import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "../ui/button";
import { useAuth } from "../../context/AuthContext";
import { toast } from "sonner";

function isComplete(formData) {
  if (!formData) return false;
  const nameParts = (formData.name || "").trim().split(/\s+/).filter(Boolean);
  return nameParts.length >= 2 && !!formData.email && !!formData.password && formData.password.length >= 6;
}

export default function AcceptTermsButton() {
  const location = useLocation();
  const navigate = useNavigate();
  const { register } = useAuth();
  const [loading, setLoading] = useState(false);
  const formData = location.state?.formData;

  const accept = async () => {
    if (isComplete(formData)) {
      setLoading(true);
      const res = await register(formData);
      setLoading(false);
      if (res.ok) {
        toast.success("Account created — welcome!");
        navigate("/", { replace: true });
      } else {
        toast.error(res.error);
        navigate("/register", { state: { formData, agreed: true } });
      }
    } else {
      navigate("/register", { state: { formData, agreed: true } });
    }
  };

  return (
    <Button type="button" onClick={accept} disabled={loading} className="bg-primary hover:bg-primary/90 h-11 px-6" data-testid="accept-all-terms-btn">
      {loading ? "Creating account…" : "I have read and accept all terms"}
    </Button>
  );
}
